import { TUploadData } from '@widgets/OrdersRecognition/model/types';

export const submitAdapter = (formData: TUploadData) => {
    const fd = new FormData();

    fd.append('file', formData.file);
    fd.append('comment', formData.comment);
    console.log('formDataFile', formData.file);
    if (formData.estimateId) {
        fd.append('estimate_id', formData.estimateId);
    }

    return fd;
};
